import {
	STORE_PORT,
	STORE_HOSTNAME,
	STORE_NONCE,
	ANCHOR_TAG,
	SCROLL_COMPONENT_TO_VIEWPORT,
	RESET_SCROLL_COMPONENT_TO_VIEWPORT
} from 'actions/miscActions';

const INITIAL_STATE = {
	hostname: '',
	shouldComponentScroll: {
		rating: false,
		qna: false,
		delivery: false
	}
};

export default function misc(state = INITIAL_STATE, action = null) {
	switch (action.type) {
		case STORE_PORT:
			return Object.assign({}, state, { port: action.payload });
		case STORE_HOSTNAME:
			return Object.assign({}, state, { hostname: action.payload });
		case STORE_NONCE:
			return Object.assign({}, state, { nonce: action.payload });
		case ANCHOR_TAG:
			return Object.assign({}, state, { anchorTagMap: action.value });
		case SCROLL_COMPONENT_TO_VIEWPORT:
			return Object.assign({}, state, {
				...state,
				shouldComponentScroll: {
					...state.shouldComponentScroll,
					[action.scrollComponentType]: action.isScrollable
				}
			});
		case RESET_SCROLL_COMPONENT_TO_VIEWPORT:
			return Object.assign({}, state, {
				shouldComponentScroll: INITIAL_STATE.shouldComponentScroll
			});
		default:
			return state;
	}
}
